import { render, staticRenderFns } from "./directory.vue?vue&type=template&id=488f4dc6&scoped=true&"
import script from "./directory.vue?vue&type=script&lang=js&"
export * from "./directory.vue?vue&type=script&lang=js&"
import style0 from "./directory.vue?vue&type=style&index=0&id=488f4dc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488f4dc6",
  null
  
)

export default component.exports